import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, FormattedHTMLMessage } from 'sb-react-intl'

import DialogModal from 'components/modals/DialogModal/DialogModal'


const optionProps = [ 'id', 'title', 'buttonTitle' ]

/**
 * @param {Object} [options] each prop except name and onClose can be Node or function (props) => (node)
 * @param {String} [options.name]
 * @param {String|Object|Function} [options.id]
 * @param {String|Object|Function} [options.title]
 * @param {String|Object|Function} [options.buttonTitle]
 * @param {String|Object|Function} [options.content] content of the modal
 * @param {Object|Object|Function} [options.contentMessage] props for FormattedMessage as a content
 * @param {Function} [options.onClose]
 * @param {Object} [options.propTypes]
 * @returns {function(*): *}
 */
export default (options = {}) => {

  class ComposedDialogModal extends Component {

    static propTypes = {
      name: PropTypes.string.isRequired,
      data: PropTypes.object,
      ...(options.propTypes || {}),
    }

    static defaultProps = {
      name: options.name,
    }

    static displayName = options.name

    componentDidMount() {
      const { onOpen } = options

      if (typeof onOpen === 'function') {
        onOpen()
      }
    }

    getOptionProp(key) {
      let value = options[key]

      if (typeof value === 'function') {
        const { props } = this

        value = value(props)
      }

      return value
    }

    handleClose = () => {
      const { data } = this.props

      if (typeof data.onClose === 'function') {
        data.onClose()
      }

      if (typeof options.onClose === 'function') {
        options.onClose()
      }
    }

    render() {
      const { name, data } = this.props

      const props = {}

      optionProps.forEach((key) => {
        props[key] = this.getOptionProp(key)
      })

      const contentMessage = this.getOptionProp('contentMessage')

      if (contentMessage) {
        props.children = Boolean(contentMessage.tag) ? (
          <FormattedHTMLMessage {...contentMessage} />
        ) : (
          <FormattedMessage {...contentMessage} />
        )
      }
      else {
        props.children = this.getOptionProp('content')
      }

      return (
        <DialogModal
          name={name}
          data={{ ...data, onClose: this.handleClose }}
          {...props}
        />
      )
    }
  }

  return ComposedDialogModal
}
